/**
 * 配送依頼（shipmentOrder）作成フォームの値
 * - formValueはフォームに許可する値。selectの初期値がない場合のnull許可などに利用する
 */

import { object, type InferOutput } from 'valibot'

import { type Nullable } from '@/libs/utils'

import {
  shipmentOrderCardEntries,
  withIncomeTaxRequiredChecks,
  withTimeRestrictionChecks
} from './shipment-order-card-schema'
import { defaultShipmentOrderCargoHandlingFormValue } from './shipment-order-cargo-handling-form-value'

const baseCreateSchema = object({ ...shipmentOrderCardEntries })

// スキーマの出力を取得する型ヘルパー
type BaseCreateSchemaOutput = InferOutput<typeof baseCreateSchema>

export const refinedCreateShipmentOrderFormValueSchema =
  withIncomeTaxRequiredChecks(withTimeRestrictionChecks(baseCreateSchema))

/**
 * 配送依頼（shipmentOrder）作成フォームの値
 */
export type CreateShipmentOrderFormValue = Nullable<
  Omit<
    BaseCreateSchemaOutput,
    'note' | 'orderNo' | 'shippingDate' | 'deliveryDate' | 'incomeRecordingDate'
  >
> & {
  note: string
  orderNo: string
  shippingDate: Date | string | null
  deliveryDate: Date | string | null
  incomeRecordingDate: Date | string | null
  truckModelId: number | null
}

/**
 * 配送依頼（shipmentOrder）作成フォームの初期値
 */
export const createDefaultShipmentOrderFormValue: CreateShipmentOrderFormValue =
  {
    orderNo: '',
    customerId: null,
    partnerId: null,
    shipmentCategoryId: null,
    originSiteId: null,
    destSiteId: null,
    originNote: null,
    destNote: null,
    // #4733: 地点の絞り込みに使ったエリア（任意）
    originAreaId: null,
    destAreaId: null,
    waypoints: [],
    shippingDate: null,
    deliveryDate: null,
    incomeRecordingDate: null,
    note: '',
    customKey1: null,
    customKey2: null,
    customKey3: null,
    customKey4: null,
    customKey5: null,
    packageCategoryId: null,
    income: null,
    incomeTaxCategoryId: null,
    incomeIsTaxInclusive: null,
    incomeRoundType: null,
    saveHistory: false,
    historyId: null,
    historyName: null,
    saveMode: undefined,
    departureTimeRestrictionStart: null,
    departureTimeRestrictionEnd: null,
    arrivalTimeRestrictionStart: null,
    arrivalTimeRestrictionEnd: null,
    ...defaultShipmentOrderCargoHandlingFormValue,
    items: [
      {
        itemCode: null,
        itemName: '',
        packagedLoadQuantity: null,
        packageCount: null,
        quantity: null,
        weight: null
      }
    ],
    truckModelId: null,
    additionalCharges: []
  }
